"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.5rem 1rem;\n  min-width: 7.5rem;\n  background-color: #f0f1f3;\n  border-radius: 999px;\n\n  p {\n    font-family: ", ";\n    font-weight: bold;\n    font-size: 1.4rem;\n    text-align: center;\n    color: #8990a3;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Label = function Label(_ref) {
  var children = _ref.children;
  return _react.default.createElement(StyledLabel, null, _react.default.createElement("p", null, children));
};

var StyledLabel = _styledComponents.default.div(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

Label.propTypes = {
  /** Content of the label */
  children: _propTypes.node.isRequired
};
var _default = Label;
exports.default = _default;